import React, { PropsWithChildren } from 'react';
import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { ICategory } from '../../../../dataObjects/models/categories/Category';
import { listViewStyles } from '../../../styles';
import CategoriesListViewItem from './CategoriesListViewItem';
import { ICategoryViewModel } from '../../../../dataObjects/viewModels/categoryViewModel';


export interface ICategoriesListViewProps extends PropsWithChildren<unknown> {
  categoryViewModels: Array<ICategoryViewModel>;
  onDelete: (category: ICategory) => void;
  onDeleteProfileImage: (categoryViewModel: ICategoryViewModel) => void;
}

export const CategoriesListView: React.FC<ICategoriesListViewProps> = (props: ICategoriesListViewProps) => {
  CategoriesListView.displayName = 'Categories List View';

  // eslint-disable-next-line no-console
  // console.info(`Render CategoriesListView`);

  const classes: Record<string, string> = listViewStyles();

  const { categoryViewModels, onDelete, onDeleteProfileImage } = props;

  return (
    <>
      {/* overall grid for list. There will be a header row and two data rows: 
          - Header Row
          - Data Row 1: Name & Action Buttons
          - Data Row 2: Description
      */}
      <Grid container direction="column" >
        {/* Header Row */}
        <Grid container className={classes.tableHeader} size={12} direction="row">
          <Grid size={{ xs: 12, md: 10 }} >
            <Typography variant='h6'>
              Name / Description
            </Typography>
          </Grid>
          <Grid container className={classes.actionButtonLabelContainer} size={{ md: 1 }} justifyContent='center' >
            {/* Only display the next label if the screen size is Medium or larger */}
            <Box sx={{ display: { xs: 'none', md: 'block' } }} >
              <Typography variant='h6'>
                Edit
              </Typography>
            </Box>
          </Grid>
          <Grid container className={classes.actionButtonLabelContainer} size={{ md: 1 }} justifyContent='center' >
            {/* Only display the next label if the screen size is Medium or larger */}
            <Box sx={{ display: { xs: 'none', md: 'block' } }} >
              <Typography variant='h6'>
                Delete
              </Typography>
            </Box>
          </Grid>
        </Grid>

        {
          categoryViewModels.map((categoryViewModel, idx) => (
            <CategoriesListViewItem
              key={categoryViewModel.category.id}
              categoryViewModel={categoryViewModel}
              onDelete={onDelete}
              onDeleteProfileImage={onDeleteProfileImage}
            />
          ))
        }
      </Grid>
    </>
  );
};

export default CategoriesListView;
